import { CategoryData } from '../../../../types/types';

export const objets: CategoryData = {
  'Kër gi (Maison)': {
    translation: 'La maison',
    translationEn: 'The house',
    illustration: '🏠',
    example: 'Kër gi rafet na. (La maison est belle.)',
    exampleEn: 'Kër gi rafet na. (The house is beautiful.)'
  },
  'Téere bi (Livre)': {
    translation: 'Le livre',
    translationEn: 'The book',
    illustration: '📖',
    audio: 'Wf-teere',
    example: 'Maa ngi jang téere bi. (Je lis le livre.)',
    exampleEn: 'Maa ngi jang téere bi. (I am reading the book.)'
  },
  'Taabal bi (Table)': {
    translation: 'La table',
    translationEn: 'The table',
    illustration: '🪑',
    example: 'Taabal bi leer na. (La table est propre.)',
    exampleEn: 'Taabal bi leer na. (The table is clean.)'
  },
  'Jëmbët bi (Chaise)': {
    translation: 'La chaise',
    translationEn: 'The chair',
    illustration: '🪑',
    example: 'Jëmbët bi nekk na fii. (La chaise est ici.)',
    exampleEn: 'Jëmbët bi nekk na fii. (The chair is here.)'
  },
  'Caabi ji (Clé)': {
    translation: 'La clé',
    translationEn: 'The key',
    illustration: '🔑',
    example: 'Caabi ji am naa ko. (J ai la clé.)',
    exampleEn: 'Caabi ji am naa ko. (I have the key.)'
  },
  'Woto bi (Voiture)': {
    translation: 'La voiture',
    translationEn: 'The car',
    illustration: '🚗',
    example: 'Woto bi ñëw na. (La voiture est arrivée.)',
    exampleEn: 'Woto bi ñëw na. (The car has arrived.)'
  },
  'Telefon bi (Téléphone)': {
    translation: 'Le téléphone',
    translationEn: 'The telephone',
    illustration: '📱',
    example: 'Telefon bi defu. (Le téléphone ne marche pas.)',
    exampleEn: 'Telefon bi defu. (The phone doesn\'t work.)'
  },
  'Bunt bi (Porte)': {
    translation: 'La porte',
    translationEn: 'The door',
    illustration: '🚪',
    example: 'Bunt bi tej na. (La porte est fermée.)',
    exampleEn: 'Bunt bi tej na. (The door is closed.)'
  },
  'Palanteer bi (Fenêtre)': {
    translation: 'La fenêtre',
    translationEn: 'The window',
    illustration: '🪟',
    audio: 'Wf-palanteer',
    example: 'Palanteer bi ubi na. (La fenêtre est ouverte.)',
    exampleEn: 'Palanteer bi ubi na. (The window is open.)'
  },
  'Cin li (Marmite)': {
    translation: 'La marmite',
    translationEn: 'The cooking pot',
    illustration: '🫕',
    example: 'Cin li ci kër gi nekk na. (La marmite est dans la maison.)',
    exampleEn: 'Cin li ci kër gi nekk na. (The cooking pot is in the house.)'
  },
  'Kaas bi (Verre)': {
    translation: 'Le verre',
    translationEn: 'The glass',
    illustration: '🥛',
    example: 'Kaas bi dara jox. (Ce verre ne vaut rien.)',
    exampleEn: 'Kaas bi dara jox. (This glass is worthless.)'
  },
  'Ndox mi (Eau)': {
    translation: 'L\'eau',
    translationEn: 'Water',
    illustration: '💧',
    audio: 'Wf-ndox',
    example: 'Ndox mi sedd na. (L\'eau est froide.)',
    exampleEn: 'Ndox mi sedd na. (The water is cold.)'
  },
  'Cééb bi (Riz)': {
    translation: 'Le riz',
    translationEn: 'Rice',
    illustration: '🍚',
    example: 'Cééb bi neex na. (Le riz est délicieux.)',
    exampleEn: 'Cééb bi neex na. (The rice is delicious.)'
  },
  'Yapp bi (Viande)': {
    translation: 'La viande',
    translationEn: 'Meat',
    illustration: '🥩',
    audio: 'Wf-yapp',
    example: 'Yapp bi lakk na ci safara wi. (La viande grille sur le feu.)',
    exampleEn: 'Yapp bi lakk na ci safara wi. (The meat is grilling on the fire.)'
  },
  'Safara si (Feu)': {
    translation: 'Le feu',
    translationEn: 'Fire',
    illustration: '🔥',
    example: 'Safara si taal na. (Le feu est allumé.)',
    exampleEn: 'Safara si taal na. (The fire is lit.)'
  },
  'Keriñ bi (Charbon)': {
    translation: 'Le charbon de bois',
    translationEn: 'Charcoal',
    illustration: '⚫',
    example: 'Keriñ bi bari na. (Il y a beaucoup de charbon.)',
    exampleEn: 'Keriñ bi bari na. (There is a lot of charcoal.)'
  },
  'Piis bi (Tissu)': {
    translation: 'Le tissu',
    translationEn: 'Fabric',
    illustration: '🧵',
    example: 'Piis bi rafet na. (Le tissu est beau.)',
    exampleEn: 'Piis bi rafet na. (The fabric is beautiful.)'
  },
  'Yéere bi (Vêtement)': {
    translation: 'Le vêtement',
    translationEn: 'Clothing',
    illustration: '👕',
    example: 'Yéere bi gaat na. (Le vêtement est petit.)',
    exampleEn: 'Yéere bi gaat na. (The clothing is small.)'
  },
  'Tubey bi (Pantalon)': {
    translation: 'Le pantalon',
    translationEn: 'Trousers',
    illustration: '👖',
    audio: 'Wf-tubey',
    example: 'Tubey bi rafet na. (Le pantalon est beau.)',
    exampleEn: 'Tubey bi rafet na. (The trousers are nice.)'
  },
  'Simis bi (Chemise)': {
    translation: 'La chemise',
    translationEn: 'The shirt',
    illustration: '👔',
    example: 'Simis bi leer na. (La chemise est propre.)',
    exampleEn: 'Simis bi leer na. (The shirt is clean.)'
  },
  'Mboub mi (Boubou)': {
    translation: 'Le boubou',
    translationEn: 'The boubou',
    illustration: '🥻',
    example: 'Mboub mi jekk na. (Le boubou est élégant.)',
    exampleEn: 'Mboub mi jekk na. (The boubou is elegant.)'
  },
  'Xaalis mi (Argent)': {
    translation: 'L\'argent',
    translationEn: 'Money',
    illustration: '💰',
    audio: 'Wf-xaalis',
    example: 'Xaalis mi amul. (Il n\'y a pas d\'argent.)',
    exampleEn: 'Xaalis mi amul. (There is no money.)'
  },
  'Gaal gi (Pirogue)': {
    translation: 'La pirogue',
    translationEn: 'The canoe',
    illustration: '🛶',
    audio: 'Wf-gaal',
    example: 'Gaal gi génn na. (La pirogue est sortie.)',
    exampleEn: 'Gaal gi génn na. (The canoe has gone out.)'
  },
  'Taksi bi (Taxi)': {
    translation: 'Le taxi',
    translationEn: 'The taxi',
    illustration: '🚕',
    example: 'Taksi bi dem na. (Le taxi est parti.)',
    exampleEn: 'Taksi bi dem na. (The taxi has left.)'
  },
  'Mbaal mi (Filet)': {
    translation: 'Le filet',
    translationEn: 'The net',
    illustration: '🥅',
    example: 'Mbaal mi yaq na. (Le filet est abîmé.)',
    exampleEn: 'Mbaal mi yaq na. (The net is damaged.)'
  },
  'Léetar bi (Lettre)': {
    translation: 'La lettre',
    translationEn: 'The letter',
    illustration: '✉️',
    example: 'Léetar bi ñëw na. (La lettre est arrivée.)',
    exampleEn: 'Léetar bi ñëw na. (The letter has arrived.)'
  },
  'Paaka bi (Couteau)': {
    translation: 'Le couteau',
    translationEn: 'The knife',
    illustration: '🔪',
    audio: 'Wf-paaka',
    example: 'Paaka bi rëy na. (Le couteau est grand.)',
    exampleEn: 'Paaka bi rëy na. (The knife is big.)'
  },
  'Siis bi (Chaise longue)': {
    translation: 'La chaise longue',
    translationEn: 'The lounge chair',
    illustration: '🪑',
    audio: 'Wf-siis',
    example: 'Siis bi nekk na ci néég bi. (La chaise longue est dans la chambre.)',
    exampleEn: 'Siis bi nekk na ci néég bi. (The lounge chair is in the bedroom.)'
  },
  'Néég bi (Chambre)': {
    translation: 'La chambre',
    translationEn: 'The bedroom',
    illustration: '🛏️',
    audio: 'Wf-neeg',
    example: 'Néég bi leer na. (La chambre est propre.)',
    exampleEn: 'Néég bi leer na. (The bedroom is clean.)'
  },
  'Tol bi (Jardin/Champ)': {
    translation: 'Le jardin',
    translationEn: 'The garden',
    illustration: '🌱',
    example: 'Tol bi mag na. (Le jardin est grand.)',
    exampleEn: 'Tol bi mag na. (The garden is big.)'
  },
  'Yoon wi (Route/Chemin)': {
    translation: 'La route',
    translationEn: 'The road',
    illustration: '🛣️',
    example: 'Yoon wi sori na. (La route est longue.)',
    exampleEn: 'Yoon wi sori na. (The road is long.)'
  },
  'Dekk bi (Ville)': {
    translation: 'La ville',
    translationEn: 'The city',
    illustration: '🏙️',
    example: 'Dekk bi mag na. (La ville est grande.)',
    exampleEn: 'Dekk bi mag na. (The city is big.)'
  },
  'Ja bi (Marché)': {
    translation: 'Le marché',
    translationEn: 'The market',
    illustration: '🏪',
    example: 'Ja bi bari nit. (Le marché a beaucoup de monde.)',
    exampleEn: 'Ja bi bari nit. (The market has a lot of people.)'
  },
  'Gaar bi (Gare)': {
    translation: 'La gare',
    translationEn: 'The station',
    illustration: '🚉',
    example: 'Gaar bi nekk na foofu. (La gare est là-bas.)',
    exampleEn: 'Gaar bi nekk na foofu. (The station is over there.)'
  },
  'Saxaar gi (Train)': {
    translation: 'Le train',
    translationEn: 'The train',
    illustration: '🚂',
    audio: 'Wf-saxaar',
    example: 'Saxaar gi dem na. (Le train est parti.)',
    exampleEn: 'Saxaar gi dem na. (The train has left.)'
  },
  'Ropulaan bi (Avion)': {
    translation: 'L\'avion',
    translationEn: 'The airplane',
    illustration: '✈️',
    example: 'Ropulaan bi ñëw na. (L\'avion est arrivé.)',
    exampleEn: 'Ropulaan bi ñëw na. (The airplane has arrived.)'
  },
  'Jumaa ji (Mosquée)': {
    translation: 'La mosquée',
    translationEn: 'The mosque',
    illustration: '🕌',
    example: 'Jumaa ji rafet na. (La mosquée est belle.)',
    exampleEn: 'Jumaa ji rafet na. (The mosque is beautiful.)'
  },
  'Lekool bi (École)': {
    translation: 'L\'école',
    translationEn: 'The school',
    illustration: '🏫',
    example: 'Lekool bi mag na. (L\'école est grande.)',
    exampleEn: 'Lekool bi mag na. (The school is big.)'
  },
  'Tabax bi (Construction)': {
    translation: 'La construction',
    translationEn: 'The construction',
    illustration: '🏗️',
    audio: 'Wf-tabax',
    example: 'Tabax bi jeex na. (La construction est finie.)',
    exampleEn: 'Tabax bi jeex na. (The construction is finished.)'
  },
  'Furnoom bi (Fourneau)': {
    translation: 'Le fourneau',
    translationEn: 'The stove',
    illustration: '🔥',
    example: 'Furnoom bi taal na. (Le fourneau est allumé.)',
    exampleEn: 'Furnoom bi taal na. (The stove is lit.)'
  },
  'Garaas bi (Garage)': {
    translation: 'Le garage',
    translationEn: 'The garage',
    illustration: '🏠',
    example: 'Garaas bi nekk na ganaw kër gi. (Le garage est derrière la maison.)',
    exampleEn: 'Garaas bi nekk na ganaw kër gi. (The garage is behind the house.)'
  },
  'Po mi (Jeu)': {
    translation: 'Le jeu',
    translationEn: 'The game',
    illustration: '🎮',
    audio: 'Wf-po',
    example: 'Po mi neex na. (Le jeu est amusant.)',
    exampleEn: 'Po mi neex na. (The game is fun.)'
  }
};

export default objets;
